export default __webpack_public_path__ + "static/media/benefit_8@3x.669048af.png";